import PageMeta from '../components/seo/PageMeta';
import LegalPage from '../components/layout/LegalPage';

export default function TermsPage() {
  return (
    <>
      <PageMeta
        title="Terms of Use | PixelUtility QR"
        description="Terms of use for the PixelUtility free QR code generator."
        path="/terms"
      />
      <LegalPage title="Terms of Use">
        <p>
          By using PixelUtility QR, you agree to these terms. If you do not agree,
          please do not use the service.
        </p>
        <h2 className="mt-8 text-xl font-semibold text-slate-900">Service</h2>
        <p className="mt-3">
          We provide a free tool to generate static QR codes. The service is offered
          &quot;as is&quot; without warranties of any kind, to the extent permitted by law.
        </p>
        <h2 className="mt-8 text-xl font-semibold text-slate-900">Your responsibility</h2>
        <p className="mt-3">
          You are responsible for the content encoded in QR codes you create and for
          compliance with applicable laws, including marketing, privacy, and intellectual
          property rules.
        </p>
        <h2 className="mt-8 text-xl font-semibold text-slate-900">Limitation</h2>
        <p className="mt-3">
          PixelUtility is not liable for indirect or consequential damages arising from
          use of generated QR codes, including broken links, misconfigured WiFi payloads,
          or third-party scanning issues.
        </p>
      </LegalPage>
    </>
  );
}
